// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"kq-z","badgeLink":"lq-z","category":"mq-z"};